import { MagnifyingGlassIcon, XCircleIcon } from '@heroicons/react/24/solid';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';
import { handleFormatingAddress, isEmptyData } from '../../../utils/helper';
import { useDispatch } from 'react-redux';
import { setUser } from '../../../store/reducers/user';
import { GOOGLE_MAP_STATUS } from '../../../utils/constants';
import { LoaderIcon, NotFoundSearchIcon, PinPointIcon, SearchLocationIcon } from '../../../utils/svg';
import { useState } from 'react';

const Result = (props) => {
	const { data = [], status, loading, onClose } = props;
	const dispatch = useDispatch();

	const handleClick = async (data = null) => {
		if (isEmptyData(data?.place_id)) return;
		await getGeocode({ placeId: data?.place_id }).then((results) => {
			const result = results[0];
			const { lat, lng } = getLatLng(result);
			const formated = handleFormatingAddress({
				lat,
				lng,
				formatted_address: result?.formatted_address || '',
				address_components: result?.address_components || {},
				detail: result?.address_detail ?? null,
			});
			dispatch(
				setUser({
					addressName: null,
					address: formated?.address,
					latitude: Number(formated?.lat),
					longitude: Number(formated?.lng),
					country: formated?.country,
					state: formated?.state,
					city: formated?.city,
					village: formated?.village,
					district: formated?.district,
					postalCode: formated?.postalCode ?? '',
					detail: null,
				}),
			);
		});
		onClose();
	};

	return (
		<div className='h-auto max-h-96'>
			{loading && (
				<div className='flex justify-center items-center w-full py-4'>
					<LoaderIcon />
				</div>
			)}
			{data?.map((item, index) => {
				return (
					<div key={item.place_id} className='[&:not(:last-child)]:border-b border-solid border-[var(--pin-ball)] p-2.5 flex items-center gap-2.5' onClick={() => handleClick(item)}>
						<PinPointIcon className='fill-gray-500 w-4 h-4 shrink-0' />
						<div className='space-y-0.5'>
							<p className='text-[var(--dark-gray)] text-sm font-semibold'>{item.structured_formatting.main_text}</p>
							{item.structured_formatting.secondary_text && <p className='text-[var(--dark-gray)] text-xxs'>{item.structured_formatting.secondary_text}</p>}
						</div>
					</div>
				);
			})}
			{status === GOOGLE_MAP_STATUS.ZERO_RESULTS && (
				<div className='py-7 px-4 flex flex-col items-center'>
					<NotFoundSearchIcon className='w-56 h-auto fill-[var(--rose-violet)]' />
					<p className='text-[var(--dark-gray)] font-semibold text-sm px-6 mb-1.5 text-center'>Hmm, tidak ada lokasi yang ditemukan</p>
					<p className='text-[var(--dark-gray)] text-xxs text-center px-14'>Kami tidak dapat menemukan apa yang Anda cari. Bagaimana kalau mencoba sesuatu yang lain??</p>
				</div>
			)}
		</div>
	);
};

const Search = (props) => {
	const {
		ready: isAutocompleteReady,
		suggestions: { data, status, loading },
		setValue: setSearch,
		clearSuggestions,
	} = usePlacesAutocomplete({
		requestOptions: { types: [] },
	});
	const [inputValue, setInputValue] = useState('');

	const handleSearch = () => {
		if (inputValue.trim().length < 3) return;

		setSearch(inputValue);
	};

	const handleCloseSearch = () => {
		setInputValue('');
		setSearch('');
		clearSuggestions();
	};

	const resultProps = { data, status, loading, ...props };

	return (
		<>
			<div className='w-full h-full flex flex-col justify-center items-center gap-2 mb-4 text-center'>
				<SearchLocationIcon />
				<div className='text-base font-semibold text-gray-800'>Pilih Lokasi Antar Terlebih Dahulu</div>
				<div className='text-xs font-thin text-gray-600'>Silahkan memilih lokasi antar dan temukan restoran terdekat dari lokasi antar anda</div>
			</div>
			<div className='flex items-center rounded-full border border-solid border-gray-200 h-8 gap-3'>
				<MagnifyingGlassIcon className={`h-7 w-7 min-w-7 min-h-7 pl-2 text-gray-600`} strokeWidth={3} />
				<input
					placeholder='Cari alamat atau nama tempat'
					value={inputValue}
					onChange={(e) => setInputValue(e.target.value)}
					className='flex-auto w-full m-0 bg-transparent border-none outline-none text-xs font-normal'
					disabled={!isAutocompleteReady}
				/>
				{!isEmptyData(inputValue) && <XCircleIcon onClick={() => handleCloseSearch()} className='h-7 w-7 text-gray-500' />}
				<div onClick={handleSearch} className={`${!isEmptyData(inputValue) ? 'bg-[var(--rose-violet)] text-white' : 'bg-gray-400 text-white'} text-xs px-3 py-1.5 rounded-full`}>
					Cari
				</div>
			</div>
			<>
				<Result {...resultProps} />
			</>
		</>
	);
};

export default Search;
